import { lazy } from "react";
import { PermissionsColpatria } from "./permissions";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

/** Rutas */
const ColpatriaTrx = lazy(() => import("./ColpatriaTrx"));
const Deposito = lazy(() => import("./Views/Deposito"));

const PinesConsulta = lazy(() => import("./Views/Pines/ConsultaPines"));
const PinesVenta = lazy(() => import("./Views/Pines/VentaPines"));
const PagoGiro = lazy(() => import("./Views/PagoGiro"));
const PinDePago = lazy(() => import("./Views/PinDePago"));

const ConsultaManual = lazy(() => import("./Views/Recaudo/ConsultaManual"));
const ConsultaBarras = lazy(() => import("./Views/Recaudo/ConsultaBarras"));
const TrxRecaudo = lazy(() => import("./Views/Recaudo/TrxRecaudo"));

const AdminColpatria = lazy(() => import("./Views/Admin"));
const ListaErrores = lazy(() => import("./Views/Admin/ListaErrores"));
const ConveniosPines = lazy(() => import("./Views/Admin/ConveniosPines"));
const ConveniosRecaudo = lazy(() => import("./Views/Admin/ConveniosRecaudo"));

const ConsultaManualSinLimite = lazy(() => import("./Views/RecaudoSinLimite/ConsultaManualSinLimite"));
const ConsultaBarrasSinLimite = lazy(() => import("./Views/RecaudoSinLimite/ConsultaBarrasSinLimite"));
const TrxRecaudoSinLimite = lazy(() => import("./Views/RecaudoSinLimite/TrxRecaudoSinLimite"));

export const rutasGestionColpatria = {
  link: "/corresponsalia/gestion",
  label: (
    <AppIcons
      Logo={"COLPATRIA_GESTION"}
      name={"Gestión Corresponsalía Colpatria"}
    />
  ),
  component: AdminColpatria,
  permission: [PermissionsColpatria.gestion],
  subRoutes: [
    {
      link: "/corresponsalia/gestion/lista-errores",
      label: (
        <AppIcons Logo={"COLPATRIA_LISTA_ERRORES"} name={"Lista de errores"} />
      ),
      component: ListaErrores,
      permission: [PermissionsColpatria.gestion_errores],
    },
    {
      link: "/corresponsalia/gestion/lista-convenios-pines",
      label: (
        <AppIcons
          Logo={"COLPATRIA_CONVENIO_PINES_RECAUDO"}
          name={"Convenios de pines de recaudo"}
        />
      ),
      component: ConveniosPines,
      permission: [PermissionsColpatria.gestion_convenios_pines],
    },
    {
      link: "/corresponsalia/gestion/lista-convenios-recaudo",
      label: (
        <AppIcons
          Logo={"COLPATRIA_CONVENIO_RECAUDO"}
          name={"Convenios de recaudo"}
        />
      ),
      component: ConveniosRecaudo,
      permission: [PermissionsColpatria.gestion_convenios_recaudo],
    },
  ],
};

const listPermissions = Object.values(PermissionsColpatria);

export const listPermissionsColpatria = listPermissions;

const rutasColpatria = {
  link: "/corresponsalia",
  label: <AppIcons Logo={"COLPATRIA"} />,
  component: ColpatriaTrx,
  permission: [PermissionsColpatria.corresponsalia_colpatria],
  subRoutes: [
    {
      link: "/corresponsalia/deposito",
      label: <AppIcons Logo={"COLPATRIA_DEPOSITO"} name={"Depósitos"} />,
      component: Deposito,
      permission: [PermissionsColpatria.deposito],
    },
    {
      link: "/corresponsalia/pines",
      label: (
        <AppIcons
          Logo={"COLPATRIA_VENTA_PINES_DE_RECAUDO"}
          name={"Venta de Pines de Recaudo"}
        />
      ),
      component: PinesConsulta,
      permission: [PermissionsColpatria.venta_pines],
      subRoutes: [
        {
          link: "/corresponsalia/pines/:id_convenio_pin",
          label: (
            <AppIcons Logo={"COLPATRIA_VENTA_PINES_DE_RECAUDO"} name={"Venta de Pines de Recaudo"} />
          ),
          component: PinesVenta,
          permission: [PermissionsColpatria.venta_pines],
          show: false,
        },
      ],
    },
    {
      link: "/corresponsalia/recaudo",
      label: (
        <AppIcons
          Logo={"COLPATRIA_RECAUDO_SERVICIOS_PUBLICOS_Y_PRIVADOS"}
          name={"Pago de Productos y Recaudo Empresarial"}
        />
      ),
      component: ColpatriaTrx,
      permission: [PermissionsColpatria.recaudo],
      subRoutes: [
        {
          link: "/corresponsalia/recaudo/manual",
          label: (
            <AppIcons
              Logo={"COLPATRIA_RECAUDO_PSE_MANUAL_EFECTIVO"}
              name={"Recaudo PSP Manual en Efectivo"}
            />
          ),
          component: ConsultaManual,
          permission: [PermissionsColpatria.recaudo],
        },
        {
          link: "/corresponsalia/recaudo/barras",
          label: (
            <AppIcons
              Logo={"COLPATRIA_RECAUDO_PSE_CODIGO_DE_BARRAS_EN_EFECTIVO"}
              name={"Recaudo PSP Código de Barras en Efectivo"}
            />
          ),
          component: ConsultaBarras,
          permission: [PermissionsColpatria.recaudo],
        },
        {
          link: "/corresponsalia/recaudo/:id_convenio_pin",
          label: <AppIcons Logo={"RECAUDO"} name={"Recaudo PSP en Efectivo"} />,
          component: TrxRecaudo,
          permission: [PermissionsColpatria.recaudo],
          show: false,
        },
      ],
    },
    {
      link: "/corresponsalia/pago-de-giro",
      label: (
        <AppIcons Logo={"COLPATRIA_RETIRO_CON_PIN"} name={"Retiro con Pin"} />
      ),
      component: PagoGiro,
      permission: [PermissionsColpatria.pago_giro],
    },
    {
      link: "/corresponsalia/pin-de-pago",
      label: <AppIcons Logo={"COLPATRIA_PIN_DE_PAGO"} name={"Pin de Pago"} />,
      component: PinDePago,
      permission: [PermissionsColpatria.pin_pago],
    },
    {
      link: "/corresponsalia/recaudo_sin_limites",
      label: (
        <AppIcons
          Logo={"COLPATRIA_RECAUDO_SERVICIOS_PUBLICOS_Y_PRIVADOS"}
          name={"Recaudo Servicios Públicos y Privados Sin Límite Máximo De Monto"}
        />
      ),
      component: ColpatriaTrx,
      permission: [PermissionsColpatria.recaudo_sin_limites],
      subRoutes: [
        {
          link: "/corresponsalia/recaudo_sin_limites/manual",
          label: (
            <AppIcons
              Logo={"COLPATRIA_RECAUDO_PSE_MANUAL_EFECTIVO"}
              name={"Recaudo PSP Manual en Efectivo"}
            />
          ),
          component: ConsultaManualSinLimite,
          permission: [PermissionsColpatria.recaudo_sin_limites],
        },
        {
          link: "/corresponsalia/recaudo_sin_limites/barras",
          label: (
            <AppIcons
              Logo={"COLPATRIA_RECAUDO_PSE_CODIGO_DE_BARRAS_EN_EFECTIVO"}
              name={"Recaudo PSP Código de Barras en Efectivo"}
            />
          ),
          component: ConsultaBarrasSinLimite,
          permission: [PermissionsColpatria.recaudo_sin_limites],
        },
        {
          link: "/corresponsalia/recaudo_sin_limites/:id_convenio_pin",
          label: <AppIcons Logo={"RECAUDO"} name={"Recaudo PSP en Efectivo"} />,
          component: TrxRecaudoSinLimite,
          permission: [PermissionsColpatria.recaudo_sin_limites],
          show: false,
        },
      ],
    },
  ],
};

export default rutasColpatria;
